import { Navigate, Outlet } from 'react-router'
import { ROUTES } from '@/shared/routes'
import { useAuth } from './useAuth'

export const ProtectedRoute = () => {
  const { isAuthenticated } = useAuth()

  if (!isAuthenticated) return <Navigate to={ROUTES.LOGIN} replace />
  return <Outlet />
}
